function AlertText() {
  const alertText = document.querySelector('aside.alert-text');
  const body = document.body;

  if(alertText) {
    const button = alertText.querySelector('button');
    const today = alertText.getAttribute('data-current-date');
    const viewed = localStorage.getItem('viewed-alert-text');

    if(!viewed || viewed !== today) {
      alertText.classList.remove('viewed');
    }

    button.addEventListener('click', function(e) {
      e.preventDefault();
      alertText.classList.add('viewed');
      body.style.setProperty('--alert-text-height', `0`);
      localStorage.setItem('viewed-alert-text', today);
    });
  }
}

export default AlertText;